








































































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      isHover: false,
    };
  },

  mounted() {
    new window.Splide(".splide", {
      type: "loop",
      perPage: 1,
      autoplay: true,
      pagination: false,
    }).mount();
  },
});
